import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useGetAvailableProducts } from '~/api';
import ProductCard from '~/components/cards/ProductCard';
import { usePaginatedQuery } from '~/hooks/usePaginatedQuery';

export function ListingsView() {
  const { t } = useTranslation('product');
  const navigate = useNavigate();

  const {
    isLoading,
    data: availableProducts,
    isLoadingMore,
    sentinelRef,
    hasMoreData,
  } = usePaginatedQuery({
    fetchHook: useGetAvailableProducts,
    select: (data) => data?.availableProducts,
  });

  return (
    <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-3 gap-4 mt-6">
      {availableProducts.map((product) => {
        const platformProduct = product.platformProductLength.platformProduct;
        return (
          <ProductCard
            key={product.id}
            productName={platformProduct.name}
            sellerName={product.organization.name}
            price={product.pricePerUnit}
            speciesCode={platformProduct.properties?.species?.code || ''}
            gradeCode={platformProduct.properties?.grade?.code || ''}
            lengthDisplayName={
              product.platformProductLength.length.displayValue
            }
            unit={'TBD'}
            quantityAvailable={10000}
            onClick={() => navigate(`/explore-products/${product.id}`)}
          />
        );
      })}
      <div
        style={{ height: '1px', background: 'transparent' }}
        ref={sentinelRef}
      ></div>
      {isLoading || isLoadingMore ? <div>{t('product.loading')}</div> : null}
      {!hasMoreData && !isLoading ? <div>{t('product.noMoreData')}</div> : null}
    </div>
  );
}
